const _ = "styles-module__results_container___OIuR5", e = "styles-module__results_container_no_rooms___gJWxi", s = "styles-module__rates_banner___AqSly", n = "styles-module__rates_banner_expanded___fGXqF", t = {
  results_container: _,
  results_container_no_rooms: e,
  "rooms-available": "styles-module__rooms-available___U3Nq3",
  "gift-cards-container": "styles-module__gift-cards-container___gwQ6f",
  rates_banner: s,
  rates_banner_expanded: n
};
export {
  t as default,
  s as rates_banner,
  n as rates_banner_expanded,
  _ as results_container,
  e as results_container_no_rooms
};
